import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { parseVpaOutcome, VPA_OUTCOME_OPTIONS, VpaOutcomeValue } from '../../../utils/vpaOutcome';

interface VpaOutcomeFieldProps {
    value: unknown;
    onChange: (value: VpaOutcomeValue) => void;
    label: React.ReactNode;
}

/**
 * SHER-759. The VPA decision as a field of the VPA form, rendered like the form's other
 * radio questions. It opens on the saved answer, so editing a consultation restores the
 * decision instead of resetting it, and nothing is chosen on a new form: a save without a
 * decision must not move the surgical request.
 */
const VpaOutcomeField: React.FC<VpaOutcomeFieldProps> = ({ value, onChange, label }) => {
    return (
        <Grid container style={{ paddingTop: '0.5rem' }}>
            <FormControl component="fieldset">
                <FormLabel component="legend">{label}</FormLabel>
                <RadioGroup
                    value={parseVpaOutcome(value) ?? ''}
                    onChange={(event) => {
                        const chosen = parseVpaOutcome(event.target.value);
                        if (chosen) {
                            onChange(chosen);
                        }
                    }}
                >
                    {VPA_OUTCOME_OPTIONS.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={<Radio inputProps={{ 'data-testid': `vpa-outcome-${option.value}` } as any} />}
                            label={<Translate id={option.labelId} />}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Grid>
    );
};

export default VpaOutcomeField;
